import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {
  constructor(private _authService: AuthService, private _router: Router) {}

  async canActivate() {
    await this._authService.init;

    if (!this._authService.authentication.isAuth) {
      return true;
    }

    await this._router.navigate(['/dashboard']);

    return false;
  }
}
